import React from 'react'
import Common from '../components/Common'
import Footer from '../components/Footer'
export default function ClientsCommunity() {
  return (
    <div>
      <Common/>
      <h1>this this clients Community page</h1>
      <Footer/>
    </div>
  )
}
